export const formatCompactInr = (amount) => {
  const n = Number(amount) || 0;
  if (n >= 10000000) {
    const v = n / 10000000;
    const s = v % 1 === 0 ? String(v.toFixed(0)) : String(v.toFixed(1));
    return `₹${s}CR`;
  }
  if (n >= 100000) {
    const v = n / 100000;
    const s = v % 1 === 0 ? String(v.toFixed(0)) : String(v.toFixed(1));
    return `₹${s}L`;
  }
  if (n >= 1000) {
    return `₹${Math.round(n / 1000)}K`;
  }
  return `₹${n}`;
};

